<template>
  <special-winner-list-card />
</template>
<script>
import SpecialWinnerListCard from "./components/SpecialWinnerListCard.vue";
export default {
  components: { SpecialWinnerListCard },
};
</script>
